export default __webpack_public_path__ + "media/images/jvqmap/marker/orange-16f2037d16f69c897171f61944985a2c.png";